<template>
  <div>
    <el-button class='button' :size="size" :type="type" @click="createBill()">
      <slot>创建提货单</slot>
    </el-button>

    <!--新增、编辑 弹出页面-->
    <el-dialog title="创建提货单" center :visible.sync="visible" :close-on-click-modal="false"
               :close-on-press-escape="false" :modal-append-to-body="false" @close="onClose">

      <div :style="{ height: (height - 300) + 'px' }" v-loading="loading">
        <div class="form-header">
          <p>
            <strong>订单号：</strong>{{ OrderId }}
            <strong style="margin-left: 20px;">产品名称：</strong> {{ orderInfo.ProductName }}
            <strong style="margin-left: 20px;">订单量：</strong>{{ orderInfo.Quantity }} 吨
            <strong style="margin-left: 20px;">已提货量：</strong> {{ orderInfo.DeliverAmount }} 吨
            <el-button class="el-icon-plus" @click="addCar" circle
                       style="font-size: 20px; float: right; margin-right: 15px" type="success"></el-button>
          </p>
          <p>
            <strong>预提量：</strong> {{ EstimateQuantity }} 吨
            <strong style="margin-left: 20px;">订单量：</strong> {{ orderAllownce }}吨
            <!--<strong style="margin-left: 20px;">客存量：</strong> {{ CustomerStock }} 吨-->
            <strong style="margin-left: 20px;">当前剩余可提货量：</strong> <span
            style="color: red; font-weight: 700; font-size: 18px">{{ sumAllownce }}</span> 吨
          </p>
        </div>
        <div class="order-bill-create-body">
          <el-form size="mini" ref='form' :model="carForm" label-width="90px" :rules="rules">
            <div class="car-item" v-for="(car, i) in carForm.cars" :key="i">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="车牌号" :rules="rules.CarNumber" :prop="'cars.'+i+'.CarNumber'">
                    <el-input v-model="car.CarNumber" @blur="onCarNumberFocus(car)" clearable
                              ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂车号" :rules="rules.CanNo" :prop="'cars.'+i+'.CanNo'">
                    <el-input v-model="car.CanNo" clearable @blur="onCarNumberFocus1(car)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="预计皮重" :rules="rules.TruckWeigthPlan"
                                :prop="'cars.'+i+'.TruckWeigthPlan'">
                    <el-input v-model="car.TruckWeigthPlan"
                              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
                              clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="7">
                  <el-form-item label="提货量" :rules="rules.LadingAmount"
                                :prop="'cars.'+i+'.LadingAmount'">
                    <el-input v-model="car.LadingAmount" clearable
                              oninput="if(isNaN(value) || value > 9999999) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}">
                      <template slot="append">吨</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="身份证号" :rules="rules.DriverIDCard"
                                :prop="'cars.'+i+'.DriverIDCard'">
                    <el-input v-model="car.DriverIDCard" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="司机姓名" :rules="rules.DriverName"
                                :prop="'cars.'+i+'.DriverName'">
                    <el-input v-model="car.DriverName" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="司机手机号" :rules="rules.DriverPhone"
                                :prop="'cars.'+i+'.DriverPhone'">
                    <el-input v-model="car.DriverPhone" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="18">
                  <el-form-item label="改装内容" :rules="rules.ModificationContent"
                                :prop="'cars.'+i+'.ModificationContent'">
                    <el-select v-model="car.ModificationContent" filterable placeholder="请选择">
                      <el-option
                        v-for="(item,index) in selectItemArr"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-button class="el-icon-delete-solid" @click="removeCar(i)" circle
                style="float: right;" type="danger"></el-button>
                </el-col>
              </el-row>
            </div>
            <div style="text-align: center;">
              <el-button type="text" @click="addCar">添加车辆</el-button>
              <el-upload class="upload-demo" style="display: inline-block" :action="url.importTplUrl"
                         :show-file-list="false" :with-credentials="true" :on-success="onAvatarSuccess"
                         :before-upload="beforeAvatarUpload" :headers="uploadHeaders">
                <el-button type="text">点击上传</el-button>
              </el-upload>
              <el-button type="text" @click="downloadTpl">下载模板</el-button>
            </div>
          </el-form>
        </div>
        <div class="order-bill-cars">
          <div class="left">
            <div>常用车辆</div>
          </div>
          <div class="right">
            <el-input style="width: 200px;margin-bottom: 10px;" size="mini" v-model="searchCar1"
                      @input="changeIt" placeholder="搜索车辆"></el-input>
            <div>
							<span v-for="(car, i) in usingCars" :key="i" class="car-tips-item"
                    @click="addCar(car)">{{ car.CarNo }}</span>
            </div>

          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <!--<el-button type="success" :disabled="loading" :loading="loading" plain @click="submit('form')"> 保 存 </el-button>-->
        <el-button type="success" :disabled="loading" :loading="loading" plain @click="submitBefore()"> 保 存
        </el-button>
        <el-button type="warning" :disabled="loading" :loading="loading" plain @click="onClose"> 关 闭
        </el-button>
      </div>
    </el-dialog>

    <el-dialog center title="信息" :visible.sync="errorTable">
      <p style="margin-bottom: 10px;">以下提货单<span style="color: red;">预计皮重</span>超出了<span
        style="color: forestgreen;">皮重阈值</span>，是否继续创建提货单?，如需创建请点击继续保存按钮！</p>
      <el-table size="mini" :data="errorData" border>
        <el-table-column property="CarNumber" label="车牌号"></el-table-column>
        <el-table-column property="TruckWeigthPlan" label="预计皮重"></el-table-column>
        <el-table-column property="TruckWeigthLimit" label="皮重阈值"></el-table-column>
        <el-table-column property="TruckWeigthCha" label="超出阈值"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="loading" :loading="loading" @click="submit">继续保存</el-button>
        <el-button type="danger" @click="errorTable = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog center title="确认车辆最小历史皮重" :visible.sync="errorTableFirst">
      <!--<p style="margin-bottom: 10px;">以下提货单<span style="color: red;">预计皮重</span>超出了<span-->
        <!--style="color: forestgreen;">皮重阈值</span>，是否继续创建提货单?，如需创建请点击继续保存按钮！</p>-->
      <el-table size="mini" :data="pWeightData" border>
        <el-table-column property="TruckNo" label="车牌号"></el-table-column>
        <el-table-column property="TruckWeigth" label="皮重"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="beforeCheck">确定</el-button>
        <el-button type="danger" @click="errorTableFirst = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  export default {
    components: {},
    props: {
      height: {
        type: Number,
        default: 600
      },
      OrderId: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      size: {
        type: String,
        default: 'small'
      }
    },
    data() {
      // 验证数量
      let validateLadingAmount = (rule, value, callback) => {
        var index = rule.field.split('.');
        if (this.sumAllownce < 0) {
          callback(new Error('提货量不能超过余量!'));
        } else if (this.carForm.cars[index[1]].LadingAmount <= 0) {
          callback(new Error('提货量应该大于0!'));
        } else {
          callback();
        }
      };
      let validateCarNo = (rule, value, callback) => {

        let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
        if (value != null && !regex.test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          if (this.HasCars && this.HasCars.length > 0) {
            let flag = this.HasCars.filter(item => item.CarNo == value);
            if (flag && flag.length > 0) {
              callback();
            } else {
              callback(new Error('此车牌号不可用'));
            }
          } else {
            callback()
          }

        }
      };
      return {
        errorTableFirst:false,
        pWeightData:[],
        types: ['xls', 'xlsx'],
        disabledflag: false,
        maxSize: 10,
        loading: true,
        carForm: {
          cars: []
        },
        HasCars: [],
        usingCarsCopy: [],
        searchCar1: null,
        usingCars: [],
        orderInfo: {
          OrderId: '',
          DeliverAmount: '',
          Quantity: '',
          EstimateQuantity: '',
          ProductName: '',
          Allowance: ''
        },
        url: {
          save: SZH.assets.api + '/Order/BatchCreateBill',
          select: SZH.assets.api + '/Order/GetCarInfoForCreateOrder',
          get: SZH.assets.api + '/Custom/GetCarForCarNum',
          getOrderAllownce: SZH.assets.api + '/Order/GetCustomOrderInfoForCeateBill',
          GetAllowCarForLongareement: SZH.assets.api + '/Order/GetAllowCarForLongareement',
          importTplUrl: SZH.assets.api + '/Import/ImportLadingCars',
          exportTplUrl: SZH.assets.api + '/Export/ExportOrderLadingModel',
          CheckBatchCreateBil: SZH.assets.api + '/Order/CheckBatchCreateBill',
          SelectItems: SZH.assets.api + '/ItemType/SelectItems',
          GetMinTruckWeigthConfim: SZH.assets.api + '/Order/GetMinTruckWeigthConfim',

        },
        rules: {
          LadingAmount: [{
            required: true,
            message: '请输入提货量',
            trigger: 'blur'
          },
            {
              validator: validateLadingAmount,
              trigger: 'blur'
            }
          ],
          TruckWeigthPlan: [{
            required: true,
            message: '请输入预计皮重',
            trigger: 'blur'
          }
          ],ModificationContent: [{
            required: true,
            message: '请选择改装内容',
            trigger: 'change'
          }
          ],
          DriverName: [{
            max: 25,
            message: '不能超过 25 个字符',
            trigger: 'blur'
          }],
          DriverIDCard: [{
            required: true,
            message: '请输入证件号码',
            trigger: 'blur'
          },
            {
              validator: validateIdCard,
              trigger: 'blur'
            }
          ],
          CarNumber: [{
            required: true,
            message: '请输入车牌号',
            trigger: 'blur'
          },
            {
              validator: validateCarNo,
              trigger: 'blur'
            }
          ],
          CanNo: [{
            required: true,
            message: '请输入挂车号',
            trigger: 'blur'
          },
            // {
            //   validator: validateCarNo,
            //   trigger: 'blur'
            // }
          ],
          DriverPhone: [{
            validator: validatePhone,
            trigger: 'blur'
          }],
        },
        form: {

        },
        visible: false,
        formTemplate: [

        ],


        errorTable: false,
        errorData: [],
        selectItemArr:[]
      }
    },
    methods: {
      changeIt() {
        if (this.searchCar1) {
          this.usingCars = this.usingCarsCopy.filter((item) => item.CarNo.indexOf(this.searchCar1) > -1);
        } else {
          this.usingCars = this.usingCarsCopy
        }
      },
      init() {
        this.carForm = {
          cars: []
        };
      },
      onClose() {
        this.visible = false;
      },
      addCar(car) {
        // this.getHasCars();
        if (this.sumAllownce <= 0) {
          return;
        }
        var c = {
          OrderNo: this.OrderId,
          LadingAmount: 0,
          DriverName: '',
          DriverIDCard: '',
          CarNumber: '',
          DriverPhone: '',
          //  xinjia
          TruckWeigthPlan: '',
          CanNo: '',
          ModificationContent: '',
        };
        if (car) {
          c.DriverName = car.Name;
          c.DriverIDCard = car.ContractsCardNumber;
          c.CarNumber = car.CarNo;
          c.DriverPhone = car.PhoneNumber;
          c.TruckWeigthPlan = car.TruckWeigthPlan;
          c.CanNo = car.CanNo;
          c.ModificationContent = car.ModificationContent;
        }
        this.carForm.cars.push(c);
      },
      getHasCars() {
        var self = this;
        self.$http.post(self.url.GetAllowCarForLongareement, {
          Data: self.OrderId
        }).then(result => {
          if (result.State == 1 && result.Data) {
            self.HasCars = result.Data;
          } else {
            self.HasCars = [];
          }
        }, () => {});
      },
      removeCar(index) {
        this.carForm.cars.splice(index, 1);
      },
      onCarNumberFocus(car) {
        car.CarNumber = (car.CarNumber || "").toUpperCase();
      },
      onCarNumberFocus1(car) {
        car.CanNo = (car.CanNo || "").toUpperCase();
      },
      createBill() {
        this.visible = true;
        var me = this;
        setTimeout(() => {
          me.form.OrderNo = this.OrderId;
        }, 100);
      },
      //确认历史皮重
      submitBefore(){
        var self = this;
        let TruckNos = [];
        if(self.carForm.cars && self.carForm.cars.length == 0){
          self.$message.error('请添加车号!');
          return
        }
        self.carForm.cars.forEach(item=>{
          TruckNos.push(item.CarNumber);
        });
        self.$http.post(self.url.GetMinTruckWeigthConfim, {
          TruckNos: TruckNos
        }).then(result => {
          if (result.state == true) {
            self.errorTableFirst = true;
            self.pWeightData = result.data;
          } else {
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      beforeCheck() {
        var self = this;
        self.errorTableFirst = false;
        self.$http.post(self.url.CheckBatchCreateBil, {
          id: self.OrderId,
          cars: self.carForm.cars
        }).then(result => {
          if (result.state == true) {
            if (result.message != 'faile') {
              self.submit();
            } else {
              self.errorTable = true;
              self.errorData = result.data;
            }
          } else {
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      submit() {
        var self = this;
        self.$refs['form'].validate(valid => {
          if (valid) {
            self.loading = true;
            self.$http.post(self.url.save, {
              id: self.OrderId,
              cars: self.carForm.cars
            }).then(result => {
              if (result.state == true) {
                self.errorTable = false;
                this.onSaved();
              } else {
                self.$message.error(result.message);
              }
              self.loading = false;
            }, () => {
              self.loading = false;
              self.$message.error('数据保存失败，请检查您的网络是否可用。');
            });
          } else {
            return false;
          }
        });
      },
      onSaved() {
        this.$message.success('提货单创建成功！');
        this.onClose();
        this.$emit('saved');
      },
      loadCars() {
        var self = this;
        self.loading = true;
        self.$http.post(self.url.select, {
          // KeyValue: self.OrderId
        }).then(result => {
          if (result.state == true && result.data && result.data.length > 0) {
            self.usingCars = result.data;
            self.usingCarsCopy = result.data;
          } else {
            self.usingCarsCopy = [];
            self.usingCars = [];
          }
          self.loading = false;
        }, () => {
          self.loading = false;
        });
      },
      getOrderAllownce() {
        var self = this;
        self.loading = true;
        self.$http.post(self.url.getOrderAllownce, {
          KeyValue: self.OrderId
        }).then(result => {
          if (result.state == true) {
            self.orderInfo = result.data;
          } else {
            self.form.Allownce = 0;
          }
          self.loading = false;
        }, () => {});
      },
      loadCard(car) {
        var self = this;
        var num = car.CarNumber;
        self.$http.post(self.url.get, {
          Data: num
        }).then(result => {
          if (result.State == 1 && result.Data) {
            if (result.Data.DriverName) car.DriverName = result.Data.DriverName;
            car.DriverIDCard = result.Data.DriverIDCard;
            if (result.Data.DriverPhone) car.DriverPhone = result.Data.DriverPhone;
          } else {}
        }, () => {});
      },
      beforeAvatarUpload(file) {

        var self = this;
        self.disabledflag = true;
        let typeIsOk = self.types.length == 0;
        const sizeIsOk = file.size / 1024 / 1024 < self.maxSize;
        for (let i = 0; i < self.types.length; i++) {
          switch (self.types[i]) {
            case "xls":
              typeIsOk = typeIsOk || file.type == "application/vnd.ms-excel";
              break;
            case "xlsx":
              typeIsOk = typeIsOk || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
              break;
            default:
              break;
          }
        }
        if (!typeIsOk) {
          var types = "[ ";
          self.types.forEach(type => {
            types += types == "[ " ? type : ', ' + type;
          });
          types += " ]";
          self.$message.error('文件格式不支持!\n仅支持 ' + types + ' 等文件格式。');
        } else if (!sizeIsOk) {
          self.$message.error('文件大小不能超过 ' + self.maxSize + 'MB!');
        }
        return typeIsOk && sizeIsOk;
      },
      onAvatarSuccess(res, file) {
        if (res.state == true) {
          this.disabledflag = false;
          if (this.carForm.cars.length > 0) {
            res.data.forEach(item => {
              this.carForm.cars.push(item)
            })
          } else {
            this.carForm.cars = res.data;
          }
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        } else {
          this.$message.error('导入失败');
        }
      },
      downloadTpl() {
        var self = this;
        // self.loading = true;
        self.$http.post(self.url.exportTplUrl, {}, {
          responseType: 'blob'
        }).then(blob => {
          var file_name = '导入模板'; //下载后文件名
          // for IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, file_name + ".xls");
          }
          // for Non-IE (chrome, firefox etc.)
          else {
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = file_name;
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
          // self.loading = false;
        }, () => {
          self.$message.error('报表导出失败，请与管理员联系。');
          // self.loading = false;
        });
      },
      loadSelect(){
        var self = this;
        self.$http.post(self.url.SelectItems, {
          keyValue:"ModificationContent"
        }).then(result => {
          if (result.state == true && result.data && result.data.length > 0) {
            self.selectItemArr = result.data;
          } else {
            self.selectItemArr = [];
          }
          self.loading = false;
        }, () => {
          self.loading = false;
        });
      }

    },
    computed: {
      DQEstimateQuantity() {
        var q = 0;
        for (var i = 0; i < this.carForm.cars.length; i++) {
          var x = parseFloat(this.carForm.cars[i].LadingAmount);
          q += isNaN(x) ? 0 : x;
        }
        var t = q;
        var tt = parseFloat(t);
        return parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
      },
      EstimateQuantity() {
        var t = this.orderInfo.EstimateQuantity + this.DQEstimateQuantity;
        var tt = parseFloat(t);
        return parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
      },
      CustomerStock() {
        var a = this.orderInfo.Quantity - this.orderInfo.EstimateQuantity - this.DQEstimateQuantity;
        var b = this.orderInfo.CustomerStock + (a < 0 ? a : 0);
        var t = b < 0 ? 0 : b;
        var tt = parseFloat(t);
        return parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
      },
      orderAllownce() {
        // var a = this.orderInfo.Quantity - this.orderInfo.EstimateQuantity - this.DQEstimateQuantity;
        var t = this.orderInfo.Allowance;
        var tt = parseFloat(t);
        return parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
      },
      sumAllownce() {
        var t = this.orderInfo.Quantity + this.orderInfo.CustomerStock - this.orderInfo.EstimateQuantity - this
          .DQEstimateQuantity;
        // var t = this.orderInfo.Allowance -this.EstimateQuantity;
        var tt = parseFloat(t);
        return parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
      },
      useCustomerStock() {
        var use = [];
        var yl = this.orderInfo.Quantity - this.orderInfo.EstimateQuantity;
        for (var i = 0; i < this.carForm.cars.length; i++) {
          var x = parseFloat(this.carForm.cars[i].LadingAmount);
          x = isNaN(x) ? 0 : x;
          var t = yl - x;
          if (t >= 0) {
            use.push(0);
            var tt = parseFloat(t);
            yl = parseFloat((isNaN(tt) ? 0 : tt).toFixed(3));
          } else {
            var tt = parseFloat(t);
            use.push(-parseFloat((isNaN(tt) ? 0 : tt).toFixed(3)));
            yl = 0;
          }
        }
        return use;
      },
      uploadHeaders() {
        var token = localStorage.ms_token;
        return {
          Authorization: 'Bearer ' + token
        };
      },


    },
    created() {


    },
    mounted() {
      // this.getOrderAllownce();
    },
    watch: {
      visible(val) {
        if (val) {
          this.getOrderAllownce();
          this.loadCars();
          this.loadSelect();
        } else {
          this.init();
        }
      },

    }
  }
</script>

<style type="text/css" scoped>
  .el-button--text {
    padding: 0;
  }

  .form-header {
    line-height: 40px;
  }

  .order-bill-create-body {
    /*height: calc(100% - 80px - 160px);*/
    height: 400px;
    border: 1px solid #ddd;
    padding: 15px;
    overflow-y: auto;
    min-height: 150px;
  }

  .car-item {
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    margin-bottom: 20px;
  }

  .order-bill-cars {
    height: 160px;
    border: 1px solid #ddd;
    border-top: none;
  }

  .order-bill-cars>.left {
    background: #888;
    height: 100%;
    width: 50px;
    float: left;
  }

  .order-bill-cars>.left>div {
    width: 15px;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    padding-top: 30px;
    color: #FFF;
  }

  .order-bill-cars>.right {
    float: left;
    height: 100%;
    width: calc(100% - 50px);
    padding: 15px;
    overflow-y: auto;
  }

  .car-tips-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 100px;
    border: 1px solid #ddd;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .car-tips-item:active {
    border: 1px solid rgb(67, 96, 192);
  }
</style>



// WEBPACK FOOTER //
// src/components/Buttons/CreateOrderBillButton.vue